/* eslint-disable jsx-a11y/media-has-caption */

import * as React from 'react';
import './Audio.css';

export default function AudioChristmas() {
  function playAudio() {
    const audioEl = document.getElementsByClassName(
      'audio-element',
    )[0] as HTMLAudioElement;
    if (!audioEl.paused) {
      audioEl.pause();
    } else {
      audioEl.play();
      audioEl.volume = 0.05;
    }
  }
  return (
    <div>
      <div
        className="App-tree__audio"
        onClick={playAudio}
        style={{
          backgroundImage: `url(./assets/svg/audio.svg)`,
        }}
      />
      <audio className="audio-element">
        <source src="./assets/audio/audio.mp3" />
      </audio>
    </div>
  );
}
